import { createUseStyles } from 'react-jss';
import color from 'color';

import { ThemeProps } from '@styles/theme';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    untoggled: {},
    disabled: {},
    appExternal: {},
    secondary: {},
    red: {},
    button: {
        border: '1px solid transparent',
        borderRadius: theme.radius,
        fontFamily: theme.font.secondary,
        textTransform: 'none',
        fontSize: 16,
        lineHeight: 1.4,
        transition: '0.3s',
        minHeight: 44,
        minWidth: 44,
        padding: `0 ${theme.spacing(5)}`,
        backgroundColor: theme.colors.violet_primary,
        color: theme.colors.white,
        position: 'relative',

        '&:focus': {
            boxShadow: `0 0 8px 0px ${color(theme.colors.violet_darker).fade(0.76)}`,
            border: `1px solid ${theme.colors.violet_primary}`,
            outline: 'none',
        },

        '&$disabled': {
            backgroundColor: theme.colors.transp_violet,
            pointerEvents: 'none',
        },

        '&$primary' : {
            '&$disabled': {
                backgroundColor: theme.colors.grey_text,
            },
        },

        '&:hover': {
            backgroundColor: theme.colors.violet_darker,
            cursor: 'pointer',
        },

        '&:active': {
            background: theme.colors.violet_darkest,
            boxShadow: 'none',
            '&:focus': {
                boxShadow: 'none',
                border: '1px solid transparent',
            },
        },

        '&$red': {
            color: `${color(theme.colors.black).fade(0.24)}`,
            backgroundColor: theme.colors.red_transparent,

            '&$disabled': {
                color: theme.colors.grey_text,
                backgroundColor: `${color(theme.colors.transp_violet).fade(0.84)}`,
                pointerEvents: 'none',
            },

            '&:hover': {
                backgroundColor: `${color(theme.colors.red).fade(0.54)}`,
                color: theme.colors.black,
                cursor: 'pointer',
            },

            '&:active': {
                background: `${color(theme.colors.red).fade(0.26)}`,
                color: theme.colors.black,
                boxShadow: 'none',
            },
        },

        '&$secondary': {
            color: theme.colors.violet_primary,
            backgroundColor: theme.colors.transp_violet,

            '&$disabled': {
                color: theme.colors.grey_text,
                backgroundColor: `${color(theme.colors.transp_violet).fade(0.84)}`,
                pointerEvents: 'none',
            },

            '&:hover': {
                backgroundColor: `${color(theme.colors.violet_darker).fade(0.84)}`,
                color: theme.colors.violet_primary,
                cursor: 'pointer',
            },

            '&:active': {
                background: `${color(theme.colors.violet_darker).fade(0.76)}`,
                color: theme.colors.violet_primary,
                boxShadow: 'none',
            },

            '&$untoggled': {
                color: theme.colors.grey_text,
                backgroundColor: `${color(theme.colors.transp_violet).fade(0.84)}`,
                boxShadow: 'none',
            },

            '&:focus': {
                boxShadow: `0px 5px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14)`,
                border: `0px`,
                outline: 'none',
            },
        },

        '&$appExternal': {
            background: theme.colors.blue_primary,
            color: theme.colors.black,
            minHeight: 52,
            padding: '6 34',

            '&$disabled': {
                color: theme.colors.white,
                opacity: .2,
                pointerEvents: 'none',
            },

            '&:hover': {
                background: theme.colors.blue_neon,
                cursor: 'pointer',
            },

            '&:active': {
                background: theme.colors.blue_neon_luminating,
                // boxShadow: 'none',
            },
            '&:focus': {
                boxShadow: `0 0 8px 0px ${color(theme.colors.blue_neon_luminating).fade(0.76)}`,
                border: `1px solid ${theme.colors.blue_neon}`,
                outline: 'none',
            },
        },
    },

    loaderWrapper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        height: 24,
    },

    loader: {
        color: theme.colors.text_heading,
        margin: '2px 4px',
    },
}));
